// extracted by mini-css-extract-plugin
export default {"features":"features__features___AZn78","feature":"features__feature___3mLUK","iconImage":"features__iconImage___13SMQ"};